<style lang="less" scoped>
    .my-album-add__textarea-w {
        padding: 0.2rem;
        //margin : 0 0.3rem;
        background: #fff;
        border-radius: 0.1rem;
        box-sizing: border-box;        
    }
    .my-textarea {
        width : 100%;
        border : none;
        font-size: 0.28rem;
        resize: none;
    }
    .my-album-add__textarea-w__tip {
        color: #9B9B9B;
        font-size: 0.24rem;
        text-align: right;
    }
    .cl-red {
        
    }
</style>
<template>
    <div class="my-album-add__textarea-w">
         <textarea class="my-textarea"  :placeholder="placeholder" @click="checkRoot" :readonly="isRealName===0" v-model="val" :rows="rows" :autofocus="autofocus"></textarea>
         <div class="my-album-add__textarea-w__tip"><span class="cl-red">{{num}}</span>/{{max}}</div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {WZ} from '../../common/globals'
export default {
    name: 'k-textarea',
    model: {
        prop: 'value',
        event: 'on-change',
    },
    props : {
        placeholder : {
            type : String,
            default : '请输入内容'
        },
        rows : {
            type : Number,
            default : 3
        },
        max : {
            type : Number,
            default : 8
        },
        autofocus : Boolean,
        value: String,
    },
    data() {
        return {
            val : '',
            num : 0
        }
    },
    computed: {
        ...mapGetters(['isRealName'])
    },
    created() {        
        this.val = this.value;
    },
    methods: {
        textareaInput(){

        },
        checkRoot(){
            if(!this.isRealName){
                this.$dialog.confirm({
                    title: '实名认证',
                    message: '大侠！混迹江湖是需要有身份嘀！你还没有实名认证，赶快去补办吧！'
                }).then(() => {
                    // on confirm
                    WZ.go('realname')
                }).catch(() => {
                // on cancel
                })                   
                return
            }
        }
    },
    watch: {
        val(v){
            let l = v.length
            this.num = l
            if(l > this.max){
                this.val = v.slice(0,this.max)
            } else {
                this.val = v.replace(/^\s+/,'')
            }
            this.$emit('on-change', this.val)
        },
        value(v){
            this.val = v
        }
    },
}
</script>